import { getBanners } from './banners';
import {
  getAMLManual,
  getCashbackRules,
  getGeneralTerms,
  getOffer,
  getPrivacyPolicy,
  getPromotion,
  getResponsibleGaming,
  getTermsOfService,
} from './documents';
import { getSlides } from './slides';


export const strapiServices = {
  banners: {
    getBanners,
  },
  slides: {
    getSlides,
  },
  documents: {
    getPrivacyPolicy,
    getAMLManual,
    getGeneralTerms,
    getResponsibleGaming,
    getTermsOfService,
    getOffer,
    getCashbackRules,
    getPromotion,
  },
};
